{
  "assetContainerEvent": {
    "types": {
      "arrived": "Arrivé",
      "arrivedWaiting": "Arrivé/En Attente",
      "loading": "Chargement",
      "loadingComplete": "Chargement Terminé",
      "unloading": "Déchargement",
      "unloadingComplete": "Déchargement Terminé",
      "readyForPickup": "Prêt pour Ramassage",
      "departed": "Parti",
      "inoperable": "Inopérable",
      "missing": "Manquant",
      "inTransit": "En transit"
    }
  },
  "assetContainerTypes": {
    "trailer": "Remorque",
    "container": "Conteneur",
    "oversized": "Surdimensionné",
    "chassis": "Châssis",
    "reefer": "Réfrigéré",
    "other": "Autre"
  },
  "assetVisitYardEvent": {
    "Arrived": "Arrivé",
    "Docked": "Amarré",
    "Parked": "Garé",
    "Unassigned": "Non assigné",
    "Dropped": "Déposé",
    "Hooked": "Attelé",
    "Appointment Linked": "Rendez-vous lié",
    "Appointment Unlinked": "Rendez-vous dissocié",
    "Status Updated": "Statut mis à jour"
  },
  "assetVisitTypes": {
    "live": "En Direct",
    "drop": "Dépôt",
    "pickup": "Accrochage",
    "dropHook": "Dépôt et Attelage"
  },
  "assetVisitDirections": {
    "inbound": "Entrée",
    "outbound": "Sortie",
    "inboundAndOutbound": "Ent. et Sort."
  },
  "loadTypeDirections": {
    "inbound": "Entrée",
    "outbound": "Sortie",
    "inOut": "Entrée et sortie",
    "load": "Chargement",
    "unload": "Déchargement",
    "dropOff": "Dépôt",
    "pickUp": "Ramassage",
    "dropAndHook": "Dépôt et accrochage",
    "inboundAndOutbound": "Entrée et sortie"
  },
  "loadTypeOperations": {
    "live": "En direct",
    "drop": "Dépôt",
    "other": "Autre"
  },
  "loadTypeTypes": {
    "standard": "Standard",
    "preparation": "Préparation"
  },
  "altAssetVisitTypes": {
    "unknown": "Inconnu"
  },
  "assetContainerStates": {
    "full": "Plein",
    "empty": "Vide",
    "partiallyLoaded": "Partiellement Chargé"
  },
  "spotStatuses": {
    "open": "ouvert",
    "closed": "fermé",
    "assigned": "assigné",
    "inTransit": "en transit",
    "reservedManual": "réservé",
    "reservedAutomated": "réservé",
    "unknown": "inconnu"
  },
  "spotTypes": {
    "parking": "stationnement",
    "docking": "quai de chargement"
  },
  "labels": {
    "licensePlate": "Plaque d'immatriculation",
    "dotNumber": "Numéro DOT"
  },
  "messages": {
    "unknownCompany": "Entreprise inconnue",
    "unhooked": "Détaché",
    "noInformationAvailable": "Aucune information disponible",
    "noVisitFound": "Aucune visite trouvée",
    "notInformed": "Non informé",
    "waitingAssignment": "Attribution en attente",
    "failedToLoadSpotDetails": "Échec du chargement des détails de la place",
    "retry": "Réessayer",
    "blockedUntilSpotIsOpen": "Bloqué jusqu’à ce que {spot} soit libre",
    "blockReasons": {
      "reservedByOther": "L’emplacement de destination est **réservé** à la **tâche de déplacement #{taskNumber}**.",
      "reservedByOtherGeneric": "L’emplacement de destination est **réservé**.",
      "destinationClosed": "L’emplacement de destination est **fermé**.",
      "destinationOccupied": "L’emplacement de destination est **occupé** par un autre actif.",
      "anotherAssetInTransitForDestination": "**{assetCode}** est déjà en transit vers cet emplacement.",
      "assetInTransitElsewhere": "L’actif est déjà déplacé par une autre tâche de déplacement."
    }
  }
}
